import {Grid, Radio, Typography} from '@yandex-delivery/blocks'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import {useController, useFormContext} from '@yandex-delivery/form'
import {noop} from '@yandex-delivery/utils'
import React, {useRef} from 'react'
import {Badge} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'
import {OrderEventGoal, useFormUserEventHandler} from 'src/shared/hooks'
import type {Order, TariffVertical} from 'src/shared/types'
import {mapVerticalToDeliveryType} from 'src/shared/utils'

import {BUSINESS_VERTICALS} from '../consts'
import * as classes from './VerticalPlate.classes'

type Props = {
  name: string
  vertical: TariffVertical
  onClick?: VoidFunction
  disabled?: boolean
  rootRef?: React.MutableRefObject<HTMLDivElement>
}

export function VerticalPlate(props: Props) {
  const {name, vertical, onClick = noop, disabled, rootRef} = props
  const {id, title, description, imgSrc} = vertical
  const ref = useRef<HTMLDivElement>(null)
  const {control, setFieldValue} = useFormContext<Order>()
  const {field, fieldState} = useController<Order>({
    // @ts-expect-error<TS2322> - TODO: fix this naming
    name,
    control,
  })
  const isBusiness = BUSINESS_VERTICALS.includes(vertical.id)
  const handleReachGoal = useFormUserEventHandler()

  function clickHandler() {
    if (rootRef && rootRef.current && ref.current) {
      scroll2element(rootRef.current, ref.current)
    }

    if (isBusiness) {
      onClick()
      handleReachGoal(OrderEventGoal.B2BWarehouseVerticalClick)
      return
    }

    if (field.value === id) {
      return
    }

    field.onChange(id)
    handleReachGoal(OrderEventGoal.VerticalClick)
    // @TODO - это тоже не должно быть здесь
    setFieldValue('deliveryType', mapVerticalToDeliveryType(id), {
      shouldValidate: false,
      shouldDirty: false,
      shouldTouch: false,
    })
  }

  return (
    <Grid
      className={classes.root}
      container
      data-e2e={`tariff-${id}`}
      direction="column"
      onPress={clickHandler}
      ref={ref}
      wrap="nowrap"
    >
      <Grid alignItems="center" container item>
        <Grid item xs>
          <img
            alt={title}
            className={classes.image}
            height={spacing(4.75)}
            loading="lazy"
            src={imgSrc}
            width={spacing(11)}
          />
        </Grid>
        <Grid item>
          <Radio
            checked={field.value === id}
            className={classes.radio}
            data-e2e={`tariff-${id}`}
            disabled={disabled}
            error={fieldState.error?.message}
          />
        </Grid>
      </Grid>
      <Grid className={classes.last} item>
        <Typography my="xs" thickness="medium" variant="body2">
          {title}
          {vertical.id === 'walking_courier' && (
            <Badge
              className={classes.badgeNew}
              isDisabled
              label={i18n('form.order.badge.new', 'New!')}
            />
          )}
        </Typography>
        {description && (
          <Typography color="minor" variant="caption2">
            {description}
          </Typography>
        )}
      </Grid>
      {isBusiness && (
        <Badge
          className={classes.badge}
          label={i18n('form.order.badge.business', 'Бизнес')}
        />
      )}
    </Grid>
  )
}

const spacing2 = parseInt(spacing(2))

function scroll2element(root: HTMLElement, item: HTMLElement) {
  const {left} = item.getBoundingClientRect()
  const scrollLeft = root.scrollLeft || 0

  root.scrollTo({
    left: scrollLeft + (left - spacing2),
    behavior: 'smooth',
  })
}
